var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"promo-event-bar"},[_c('div',{staticClass:"promo-event-bar__progress",class:[
      'promo-event-bar__progress',
      {
        'promo-event-bar__progress--blackfriday': _vm.$store.state.isBlackFriday,
      } ],style:(_vm.progressStyle)})])}
var staticRenderFns = []

export { render, staticRenderFns }